export const useMoveableLabel = ({ label, value }) => {
  const moveableLabel = label === "moveable";

  const labelClassName = !moveableLabel
    ? false
    : `input-label moveable${value ? " focused" : ""}`;

  return { labelClassName };
};

export default useMoveableLabel;
